namespace Factive {

    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import GameMain = Factive.Game.GameMain;
    let window:any;

    export class Autotest {
        private _dependenciesContainer: DependenciesContainer;

        public static instancesList: Array<Autotest> = [];
        public $root: GameMain;

        constructor(private window,
                    options) {
            window.__Factive__Autotest__ = Autotest;
            this.$root = options.root;
            Autotest.instancesList.push(this);
        }

        public static factory: any = {
            get (window, options) {
                return new Autotest(window, options);
            },
            dependency: ['Window', 'Options']
        };
    }
}


// WEBPACK FOOTER //
// src/typescript/Autotest.ts